<script>
    import {links, navigate} from "svelte-routing";
    import Time from "svelte-time";
    import FileManagerComponent from "./ImageManagement/FileManagerComponent.svelte";
    import {getContext} from "svelte";
    import Service from "./utils/Service";
    import NewFormComponent from "./FormItem/NewFormComponent.svelte";
    import NewMapComponent from "./MapItem/NewMapComponent.svelte";
    import {FlatToast, ToastContainer, toasts} from "svelte-toasts";
    import CommentsComponent from "./Comments/CommentsComponent.svelte";

    const { open } = getContext('simple-modal');

    export let mid;
    export let sort_by;
    export let model_root;
    export let application_root;

    const service = new Service(model_root);

    $ : contentItems = loadContentItems(mid);

    function loadContentItems(id) {
        return fetch(model_root + 'shared/contents/load_contents_details.php?mid=' + id + "&order=" + sort_by, {
            method: "GET"
        })
            .then(response => {
                window.scrollTo(0, 0);
                return response.json();
            });
    }

    function reloadContentItems() {
        contentItems = loadContentItems(mid);
    }

    function openFileManager(cid, type) {
        open(FileManagerComponent, {
            model_root: model_root,
            application_root: application_root,
            content_id: cid,
            file_type: type
        }, {}, {
            onClosed: () => { }
        });
    }

    async function deleteItem(id) {
        if (!confirm(`Soll dieser Inhalt wirklich entfernt werden? Dies kann nicht rückgängig gemacht werden!\n\nBitte beachten Sie, dass hierdurch auch die zugehörigen Bilder und Anhänge unwiderruflich gelöscht werden.`)) {
            return;
        }

        const files = await service.loadFiles(id, "image");
        files.push(...await service.loadFiles(id, "file"));
        for (const file of files) {
            console.log(`${file.fname} wird gelöscht...`)
            await service.removeFile(file.fid);
        }
        console.log("Alle Bilder und Anhänge wurden erfolgreich gelöscht.")
        try {
            const response = await fetch(model_root + 'admin/contents/delete_content.php?cid=' + id, {
                method: "GET"
            }).then(response => response.text());
            if (response === "success") {
                console.log("Inhalt wurde erfolgreich gelöscht.")
                reloadContentItems();
            } else {
                throw new Error(response);
            }
        } catch (e) {
            console.error("Ein Fehler ist aufgetreten: " + e);
        }

        //alert("Noch nicht funktional. Solange dies der Fall ist, einfach Bescheid geben und ich werde den Eintrag manuell entfernen.");
    }

    function togglePin(id, value) {
        const data = new FormData();
        data.append("cid", id);
        data.append("pin", value);

        fetch(model_root + 'admin/contents/toggle_pin.php', {
            method: "POST",
            body: data
        })
            .then(response => response.text())
            .then(msg => {
                (msg === "success") ? reloadContentItems() : showErrorMsg(msg);
            });
    }

    function toggleVisibility(id, value) {
        const data = new FormData();
        data.append("cid", id);
        data.append("visible", value);

        fetch(model_root + 'admin/contents/toggle_visibility.php', {
            method: "POST",
            body: data
        })
            .then(response => response.text())
            .then(msg => {
                (msg === "success") ? reloadContentItems() : showErrorMsg(msg);
            });
    }

    function toggleComments(id, value) {
        const data = new FormData();
        data.append("cid", id);
        data.append("comments_active", value);

        fetch(model_root + 'admin/contents/toggle_comments.php', {
            method: "POST",
            body: data
        })
            .then(response => response.text())
            .then(msg => {
                (msg === "success") ? reloadContentItems() : showErrorMsg(msg);
            });
    }

    function moveItem(cid, direction) {
        const data = new FormData();
        data.append("cid", cid);
        data.append("direction", direction);

        fetch(model_root + 'admin/contents/move_item.php', {
            method: "POST",
            body: data
        })
            .then(response => response.text())
            .then(msg => {
                (msg === "success") ? reloadContentItems() : showErrorMsg(msg);
            });
    }

    function openEditFormComponent(cid, cname) {
        open(NewFormComponent, {
            model_root: model_root,
            cid: cid,
            cname: cname
        }, {}, {
            onClosed: () => {

            }
        });
     }

    function openCommentsModal(cid, cname) {
        open(CommentsComponent, {
            model_root: model_root,
            cid: cid,
            cname: cname
        }, {}, {
            onClosed: () => {

            }
        });
    }

    function showErrorMsg(msg) {
        toasts.error('Ein Fehler ist aufgetreten', msg, {duration: 10000})
    }
</script>

<ToastContainer placement="bottom-right"
                showProgress="true"
                let:data={data}>
    <FlatToast {data} />
</ToastContainer>

<div use:links>
    {#await contentItems}
        <p class="alert alert-light">
            <i class="fas fa-circle-notch fa-spin"></i> Lade Inhalte...
        </p>
    {:then items}

        <div class="bg-light rounded pt-4 pb-2 px-4 mt-2">

            {#each items as content}

                <div class="card mb-4 pb-2 border-0 bg-white shadow-sm"
                     class:pinned={content.cpinned === "1"}
                     class:not-visible={content.cvisible === "0"}
                >
                    <div class="row g-0">
                        <div class="col-md-2">
                            <div class="pt-4 text-center">
                                {#if content.ctype === "TEXT_CONTENT"}
                                    <button class="btn btn-light shadow-sm" on:click={() => { openFileManager(content.cid, "image") }}>
                                        <i class="far fa-images"></i><br>
                                        Bilder<br>verwalten
                                    </button>
                                {:else if content.ctype === "FORM_CONTENT"}
                                    <button class="btn btn-light shadow-sm" on:click={() => { openEditFormComponent(content.cid, content.cname) }}>
                                        <i class="fas fa-th-list"></i><br>
                                        Formular<br>verwalten
                                    </button>
                                {:else if content.ctype === "MAP_CONTENT"}
                                    <button class="btn btn-light shadow-sm" on:click={() => { navigate("/edit-map-data/"+mid+"/"+content.cid+"/"+content.cname, { replace: false }) }}>
                                        <i class="fas fa-map"></i><br>
                                        Karte<br>verwalten
                                    </button>
                                {/if}
                            </div>
    <!--                        <img src="..." alt="...">-->
                        </div>
                        <div class="col-md-10">
                            <div class="card-body">
                                <h5 class="card-title">
                                    {@html content.cname}

                                    {#if content.ctype === "FORM_CONTENT"}
                                        <i class="fas fa-comment-alt text-muted small ms-1"></i>
                                    {/if}
                                    {#if content.ctype === "MAP_CONTENT"}
                                        <i class="fas fa-map text-muted small ms-1"></i>
                                    {/if}
                                    {#if content.cpinned === "1"}
                                        <i class="fas fa-thumbtack text-muted small ms-1"></i>
                                    {/if}
                                    {#if content.cvisible === "0"}
                                        <i class="fas fa-eye-slash text-muted small ms-1"></i>
                                    {/if}

                                    <div class="dropdown float-end ms-1">
                                        <button class="btn btn-light shadow-sm" type="button" id="dropdownItemActions" data-bs-toggle="dropdown" aria-expanded="false">
                                            <i class="fas fa-ellipsis-h"></i>
                                        </button>
                                        <ul class="dropdown-menu" aria-labelledby="dropdownItemActions">
                                            {#if content.cpinned === "0"}
                                                <li><button on:click={() => { togglePin(content.cid, 1) }} class="dropdown-item"><i class="fas fa-thumbtack"></i> Anpinnen</button></li>
                                            {:else}
                                                <li><button on:click={() => { togglePin(content.cid, 0) }} class="dropdown-item"><i class="fas fa-ban"></i> Pin lösen</button></li>
                                            {/if}
                                            {#if content.cvisible === "0"}
                                                <li><button on:click={() => { toggleVisibility(content.cid, 1) }} class="dropdown-item"><i class="fas fa-eye"></i> Anzeigen</button></li>
                                            {:else}
                                                <li><button on:click={() => { toggleVisibility(content.cid, 0) }} class="dropdown-item"><i class="fas fa-eye-slash"></i> Verstecken</button></li>
                                            {/if}
                                            {#if content.ctype === "TEXT_CONTENT"}
                                                {#if content.ccomments_active === "0"}
                                                    <li><button on:click={() => { toggleComments(content.cid, 1) }} class="dropdown-item"><i class="fas fa-comment"></i> Kommentare aktivieren</button></li>
                                                {:else}
                                                    <li><button on:click={() => { toggleComments(content.cid, 0) }} class="dropdown-item"><i class="fas fa-comment-slash"></i> Kommentare deaktivieren</button></li>
                                                {/if}
                                            {/if}
                                            <div class="dropdown-divider"></div>
                                            <li><button on:click={() => { navigate("/edit-content/"+mid+"/"+content.cid, { replace: false }) }} class="dropdown-item"><i class="fas fa-edit"></i> Inhalt bearbeiten</button></li>
                                            {#if content.ctype === "TEXT_CONTENT"}
                                                <li><button on:click={() => { openFileManager(content.cid, "file") }} class="dropdown-item"><i class="fas fa-paperclip"></i> Anhänge verwalten</button></li>
                                            {/if}
                                            <div class="dropdown-divider"></div>
                                            <li><button on:click={() => { deleteItem(content.cid) }} class="dropdown-item"><i class="fas fa-trash-alt"></i> Löschen</button></li>
                                        </ul>
                                    </div>

                                    {#if sort_by === "manually"}
                                        <button on:click={() => {moveItem(content.cid, "down")}}  class="btn btn-light shadow-sm float-end mx-1 sort-down" title="Eine Ebene nach unten"><i class="fas fa-angle-down"></i></button>
                                        <button on:click={() => {moveItem(content.cid, "up")}}  class="btn btn-light shadow-sm float-end mx-1 sort-up" title="Eine Ebene nach oben"><i class="fas fa-angle-up"></i></button>
                                    {/if}

                                </h5>

                                {#if content.ccomments_active === "1"}
                                    <div class="w-100 mb-2">
                                        <button class="badge bg-info text-dark border-0" on:click={() => {openCommentsModal(content.cid, content.cname)}}>
                                            <i class="fas fa-info-circle"></i> Kommentarbereich aktiv
                                        </button>
                                    </div>
                                {/if}
                                <p class="card-text">{@html content.ctext.replace(/<[^>]*>?/gm, '').split(/\s+/).slice(0,10).join(" ")} ...</p>
                                <p class="card-text">
                                    <small class="text-muted">{@html content.cauthor},</small>
                                    <small class="text-muted"><Time timestamp="{content.ctimestamp}" format="DD.MM.YYYY" /></small>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>

            {/each}

        </div>

    {:catch error}
        <p style="color: red">{error.message}</p>
    {/await}
</div>

<style>
    .pinned {
        border: solid 1px #d35400 !important;
    }

    .not-visible {
        color: #6c7a89;
    }
</style>
